<template>
	<el-dialog :title="$t('index.add_student')" data-title="添加学生" width="1000px" :close-on-click-modal="false" :visible="editFormVisible" @close="guanbitanchu" append-to-body>
		<el-row class="tree-content" :gutter="20">
			<el-form :model="editForm" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-col :span="12">
					<el-form-item :label="$t('student_list.parent_id')" prop="user_id">
						<el-input :value="editForm.user_id" placeholder="">
							<el-button slot="append" @click="init">{{$t('index.select')}}</el-button>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('student_list.student_id')" prop="child_id">
						<el-input :value="editForm.child_id" placeholder=""></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('student_list.parent_name')">
						<el-input :value="editForm.user_name" readonly  placeholder=""></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('student_list.name')">
						<el-input :value="editForm.child_name" readonly  placeholder=""></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('student_list.time')" prop="plan_id">
						<el-select v-model="editForm.plan_id" multiple class="w100" placeholder="请选择">
							<el-option v-for="(item,index) in plan_list" :key="index" :label="
							getTime_us(item.start_time,'mmddyyyy')+'~'+getTime_us(item.end_time,'mmddyyyy') + getTime_us(item.start_time,'hh:ii')+'!'+getTime_us(item.end_time,'hh:ii') " :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-form>
		</el-row>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click.native="guanbitanchu">{{$t('index.cancel')}}</el-button>
			<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
		</div>
		<el-dialog width="800px" :label="$t('student_list.parent_name')" :visible.sync="innerVisible" append-to-body @close="innerVisible = false" :close-on-click-modal="false">
			<el-form :inline="true" size="mini" :model="filters" ref="filters">
				<el-form-item :label="$t('student_list.email')">
					<el-input v-model="filters.email" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" type="primary" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="list" border size="mini">
				<el-table-column prop="id" align="center" :label="$t('student_list.parent_id')" data-name="家长ID"></el-table-column>
				<el-table-column prop="name" align="center" :label="$t('student_list.parent_name')" data-name="家长姓名"></el-table-column>
				<el-table-column prop="email" align="center" :label="$t('student_list.email')" data-name="email"></el-table-column>
				<el-table-column prop="child_id" align="center" :label="$t('student_list.student_id')" data-name="学生ID"></el-table-column>
				<el-table-column prop="child_name" align="center" :label="$t('student_list.name')" data-name="学生"></el-table-column>
				<el-table-column :label="$t('index.operation')" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="determine(scope.row)">{{$t('index.determine')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="page-pagination">
				<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
			</div>
		</el-dialog>
	</el-dialog>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				user_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('student_list.parent_id'),
					trigger: ['blur','change'],
				}],
				child_id: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.student_id'),
					trigger: ['blur','change'],
				}],
				plan_id: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.time'),
					trigger: ['blur','change'],
				}],
			}
		},
	},
	props: {
		isdialog: {
			type: Boolean,
			default: false
		},
		id:{
			type:String,
			default: 0
		},
	},
	data() {
		return {
			editFormVisible: false,
			innerVisible: false,
			editForm: {
				user_id:'',
				child_id:'',
				plan_id:[],
			},
			filters: {
				email: '',
			},
			plan_list:[],
			list: [],
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
		}
	},
	watch: {
		isdialog(v){
			this.editFormVisible=v;
			if (v) {
				this.config();
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		// 初始化
		config() {
			var this_ = this;
			var url = "noBuyPlanList";
			var datas = {
				private_course_id: this_.id,
				now_time:Math.round(new Date().getTime()/1000),
			};
			this_.$post(url, datas).then((res) => {
				this_.plan_list = res;
			})
		},
		// 查找学生
		init() {
			var this_ = this;
			var url = "userSearch";
			var datas = {
				email: this_.filters.email,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
				this_.innerVisible = true;
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		determine(data) {
			var this_ = this;
			this_.editForm['user_id'] = data.id;
			this_.editForm['user_name'] = data.name;
			this_.editForm['child_id'] = data.child_id;
			this_.editForm['child_name'] = data.child_name;
			this_.innerVisible = false;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						user_id: this_.editForm.user_id,
						child_id: this_.editForm.child_id,
						private_course_id:this_.id,
						plan_id:this_.editForm.plan_id.join(','),
					}
					var url = "addPrivateChild";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.editForm={
							user_id:'',
							child_id:'',
							plan_id:[],
						};
						this_.$emit("guanbitanchu",true);
						this_.$refs['filters'].resetFields();
					});
				} else {
					return false;
				}
			})
		},
		guanbitanchu(){
			this.$emit("guanbitanchu");
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.clo3 {
	color: #ff0000;
}
.filter-panel{
	width:calc( 100% - 400px );
	float: left;
}
.title{
	text-align: center;
	font-size: 20px;
	margin-top: 10px;
	line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/private_student_list.vue